import React from 'react'
import useSWRImmutable from 'swr/immutable'

import Loading from '../../components/layout/Loading'
import SelectInput from '../../components/form/SelectInput'
import { useI18N } from '../../../libraries/i18n/hook'
import { getAllSpainCities } from '../../../api/job-offers'

type Props = {
  onChange: (values: { cityIds: string[] }) => void,
  values?: string[]
  label?: string
}
const CitiesSelectBox: React.FC<Props> = ({ onChange, values, label }) => {
  const { t } = useI18N()
  const { data, isLoading } = useSWRImmutable('spain-cities', getAllSpainCities)

  if(isLoading) return <Loading />

  const handleChange = (ids: string[]) => {
    onChange({ cityIds: ids })
  }

  const options = data?.map(({ name, id }) => ({ label: name, value: id.toString() }))
  if(!options) return null
  return (
    options && (
      <SelectInput
        isDisabled={options?.length === 0}
        value={options?.filter(city => values?.includes(city.value.toString()))}
        name='cityIds'
        label={label ?? t('common.cities')}
        onChange={handleChange}
        options={options}
        autoMinWidth
      />
    )
  )
}

export default CitiesSelectBox
